import {
  BotObject,
  ChatbotValue,
} from "../../../services/api/instances/botApi/types";
import { NormalizedStorageObject } from "../../../services/api/instances/storageApi/types/object_types";

export const isTokenExist = (token: string, bots: BotObject[]) =>
  bots.some((item) => item?.bot_api === token);

export const getBotObjects = (
  bots: Record<string, NormalizedStorageObject<ChatbotValue>>,
) =>
  Object.values(bots).reduce(
    (acc: BotObject[], item: NormalizedStorageObject<ChatbotValue>) => {
      if (item?.value === null) {
        return [...acc];
      } else if (item?.value !== null) {
        return [...acc, item?.value?.tg_bot_object];
      }
      return acc;
    },
    [],
  );

export const getBots = (bots: NormalizedStorageObject<ChatbotValue>[]) =>
  bots.reduce(
    (acc: BotObject[], item: NormalizedStorageObject<ChatbotValue>) => {
      if (item?.value === null) {
        return [...acc];
      } else if (item?.value !== null) {
        return [...acc, item?.value?.tg_bot_object];
      }
      return acc;
    },
    [],
  );

export const processList = (list: string[] | null) => {
  if (!Array.isArray(list)) return null;
  const filtered = list.filter(
    (item) =>
      item != null && typeof item === "string" && !item.includes("mock-"),
  );
  return filtered.length ? filtered : null;
};

export const findSecureBot = (
  objects: NormalizedStorageObject<ChatbotValue>[],
  secureBotName: string,
): BotObject | null => {
  const bot = objects.find(
    (bot) => bot?.value?.tg_bot_object?.secure_bot_name === secureBotName,
  );
  return bot?.value?.tg_bot_object ? bot.value.tg_bot_object : null;
};
